import * as types from './constants'

const initialState = {
  stores: [],
  allStores: [],
  searchValue: '',
  searchValueOnClick: '',
  storesLoaded: false,
  overlayIsShowing: false,
  storeName: '',
  editOverlayIsShowing: false,
  currentStore: null,
  status: true,
  items: [],
  pageOfItems: [],
}

const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LOCATIONS:
      return {
        ...state,
        stores: action.stores,
      }
    case types.SET_ALL_LOCATIONS:
      return {
        ...state,
        allStores: action.stores,
      }
    case types.SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.searchValue,
      }
    case types.SET_SERACH_VALUE_ON_CLICK:
      return {
        ...state,
        searchValueOnClick: action.value,
      }
    case types.SET_STORES_LOADED:
      return {
        ...state,
        storesLoaded: action.value,
      }
    case types.TOGGLE_OVERLAY:
      return {
        ...state,
        overlayIsShowing: !state.overlayIsShowing,
      }
    case types.TOGGLE_EDIT_OVERLAY:
      return {
        ...state,
        editOverlayIsShowing: !state.editOverlayIsShowing,
      }
    case types.SET_STORE_NAME:
      return {
        ...state,
        storeName: action.value,
      }
    case types.SET_STORE_ID:
      return {
        ...state,
        storeId: action.value,
      }
    case types.TOGGLE_STATUS:
      return {
        ...state,
        status: !state.status,
      }
    case types.SET_CURRENT_STORE:
      return {
        ...state,
        currentStore: action.value,
      }
    case types.SET_CURRENT_STORE_NAME:
      return {
        ...state,
        currentStore: {
          ...state.currentStore,
          name: action.value,
        },
      }
    case types.SET_CURRENT_STORE_ID:
      return {
        ...state,
        currentStore: {
          ...state.currentStore,
          location_id: action.value,
        },
      }
    case types.TOGGLE_CURRENT_STATUS:
      console.log('state currentstore', state.currentStore)
      console.log('state state.currentStore.status', state.currentStore.status)
      return {
        ...state,
        currentStore: {
          ...state.currentStore,
          status: !state.currentStore.status,
        },
      }
    case types.SET_ITEMS:
      return {
        ...state,
        items: action.items,
      }
    case types.SET_PAGE_OF_ITEMS:
      return {
        ...state,
        pageOfItems: action.pageOfItems,
      }
    default:
      return state
  }
}

export default storeReducer
